export const Routes = {
    // public routes
    Signin: { path: "/sign-in" },
    LoginWithOtp: { path: "/login-with-otp" },
    Register: { path: "/register" },
    ReferralValidate: { path: "/referral-validate" },
    ForgotPassword: { path: "/forgot-password" },
    ChangePassword: { path: "/change-password" },
    ResetPassword: { path: "/examples/reset-password" },
    NotFound: { path: "/examples/404" },
    ServerError: { path: "/examples/500" },


    // Admin Routes
    AdminDashboard: { path: "/admin-dashboard" },
    AdminCourseList: { path: "/admin-course-list" },
    AdminSendNotifications: { path: "/admin-send-notifications" },
    AdminProfilePage: { path: "/admin-profile-page" },
    AdminCommissionList: { path: "/admin-commission-list" },
    AdminLevelCommissions: { path: "/admin-level-commissions/:configId" },
    AdminUserManagement: {path: "/admin-user-management"},
    AdminAddUser: {path: "/admin-add-user"},
    AdminEditUser: {path: "/admin-edit-user/:id"},
    AdminUserDetails: {path: "/admin-user-details/:id"},
    AdminTransactionHistory: {path: "/admin-transaction-history"},
    AdminSettlementHistory: {path: "/admin-settlement-history"},
    AdminReports: {path: "/admin-reports"},
    AdminPaymentConfirmList: {path: "/admin-payment-confirm-list"},
    AdminWithdrawalRequests: {path: "/admin-withdrawal-requests"},
    AdminBonusDashboard: {path: "/admin-bonus-dashboard"},
    AdminBonusSlabSetup: {path: "/admin-bonus-slab-setup"},
    AdminEligibleUsers: {path: "/admin-eligible-users"},
    AdminBonusHistory: {path: "/admin-bonus-history"},
    AdminEarningStatement: {path: "/admin-earning-statement"},
    AdminSupportTicketList: {path: "/admin-support-ticket-list"},
    AdminRefundManagement: {path: "/admin-refund-management"},
    AdminUserTransactionHistory: {path: "/admin-user-transactions/:id"},
    AdminUserCourseList: {path: "/admin-user-courses/:id"},
    AdminLogs: {path: "/admin-logs"},

     // User Routes
    UserProfilePage: { path: "/user-profile" },
    UserDashboard: { path: "/user-dashboard" },
    UserMyCourseList: { path: "/user-my-course-list" },
    UserMyReferrals: { path: "/user-my-referrals"},
    UserLevelEarning: { path: "/user-level-earning"},
    UserPurchaseCourseList: { path: "/user-purchase-course-list" },
    UserLevelNetworkPage: {path: "/user-level-network-page"},
    UserWalletPage:{path: "/user-wallet-page"},
    UserMyPayments: {path: "/user-my-payments"},
    UserInvoices: {path: "/user-invoices"},
    UserCreditNotes: {path: "/user-credit-notes"},
    UserGst: {path: "/user-payments/gst"},
    UserTds: {path: "/user-payments/tds"},
    UserWithdrawalHistory: {path: "/user-withdrawal-history"},
    UserReports: {path: "/user-reports"},
    UserSupportTicketList: {path: "/user-support-ticket-list"},
    UserRefundManagement: {path: "/user-refund-management"},

    UserMyBonus: {path: "/user-my-bonus"},
    UserMyIds: { path: "/user-my-ids" },
    UserMyTeam: { path: "/user-my-team" },
    UserCollaborativePurchase: { path: "/user-collaborative-purchase" },
    UserSettlementHistory: {path: "/user-settlement-history"},

    SearchResults: {path: "/search-results"},

};